import React from 'react';
import { Flex, JoyKitThemeProvider, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { Info } from '@withjoy/joykit/icons';
import { useEventInfo } from '@shared/utils/eventInfo';
import { isEventMoreThanNDaysAway } from '@shared/utils/dateHelpers';

export const SoldOutTag = () => {
  const { tq } = useTranslation('sharedComponents');
  const { finalizedEventDate } = useEventInfo();

  const isMoreThan365Days = isEventMoreThanNDaysAway(finalizedEventDate ?? null, 365);

  const message = isMoreThan365Days ? tq`This hotel hasn't opened bookings for the event dates yet.` : tq`This hotel is fully booked for the event dates.`;

  return (
    <JoyKitThemeProvider>
      <Flex
        width={'100%'}
        gap={3}
        alignItems="center"
        color="negative6"
        marginTop={5}
      >
        <Info size={16} />
        <TextV2 typographyVariant={'label2'}>{message}</TextV2>
      </Flex>
    </JoyKitThemeProvider>
  );
};
